<template>
  <div class="c-checkbox-filter l-flex l-flex--column l-flex--align-start">
    <checkbox
      v-for="value in values"
      :key="value"
      class="c-checkbox-filter__option"
      :value="isEnabled(value)"
      @input="toggleFilter(value)"
    >
      {{ getLabel(value) }}
    </checkbox>
  </div>
</template>

<script>
import FilterMixin from '@/mixins/filter';
import Checkbox from '../checkbox/Checkbox'

export default {
  components: {
    Checkbox
  },
  mixins: [
    FilterMixin
  ],
  props: {
    mapLabel: {
      type: Function,
      default: (value) => value
    }
  },
  methods: {
    getLabel(value) {
      try {
        return this.mapLabel(value)
      } catch (err) {
        console.error(err)
        return value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.c-checkbox-filter {
  width: 100%;

  &__option {
    &:not(:last-child) {
      margin-bottom: rem(10px);
    }
  }
}
</style>
